import React from 'react';

export const VerifiedCheck = ({ className = '' }) => (
  <svg
    className={className}
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.77813 8.21161L6.89246 9.16274C7.11555 9.35315 7.44749 9.3402 7.65506 9.13298L10.5219 6.27098M6.0841 2.09219V2.09219C5.62013 1.89918 5.08764 2.11975 4.89605 2.58429V2.58429C4.75565 2.9247 4.42356 3.1466 4.05533 3.14604V3.14604C3.55283 3.14527 3.14527 3.55283 3.14604 4.05533V4.05533C3.1466 4.42356 2.9247 4.75565 2.58429 4.89605V4.89605C2.11975 5.08764 1.89918 5.62013 2.09219 6.08409V6.08409C2.23362 6.42407 2.1557 6.81581 1.89493 7.07578V7.07578C1.53906 7.43057 1.53906 8.00693 1.89493 8.36172V8.36172C2.1557 8.62169 2.23362 9.01343 2.09219 9.3534V9.3534C1.89918 9.81737 2.11975 10.3499 2.58429 10.5415V10.5415C2.9247 10.6818 3.1466 11.0139 3.14604 11.3822V11.3822C3.14527 11.8847 3.55283 12.2922 4.05533 12.2915V12.2915C4.42356 12.2909 4.75565 12.5128 4.89605 12.8532V12.8532C5.08764 13.3178 5.62013 13.5383 6.0841 13.3453V13.3453C6.42407 13.2039 6.81581 13.2818 7.07578 13.5426V13.5426C7.43057 13.8984 8.00694 13.8984 8.36172 13.5426V13.5426C8.6217 13.2818 9.01343 13.2039 9.35341 13.3453V13.3453C9.81737 13.5383 10.3499 13.3178 10.5415 12.8532V12.8532C10.6819 12.5128 11.0139 12.2909 11.3822 12.2915V12.2915C11.8847 12.2922 12.2922 11.8847 12.2915 11.3822V11.3822C12.2909 11.0139 12.5128 10.6818 12.8532 10.5415V10.5415C13.3178 10.3499 13.5383 9.81737 13.3453 9.35341V9.35341C13.2039 9.01343 13.2818 8.62169 13.5426 8.36172V8.36172C13.8984 8.00693 13.8984 7.43057 13.5426 7.07578V7.07578C13.2818 6.81581 13.2039 6.42407 13.3453 6.08409V6.08409C13.5383 5.62013 13.3178 5.08764 12.8532 4.89604V4.89604C12.5128 4.75565 12.2909 4.42356 12.2915 4.05533V4.05533C12.2922 3.55283 11.8847 3.14527 11.3822 3.14604V3.14604C11.0139 3.1466 10.6819 2.9247 10.5415 2.58429V2.58429C10.3499 2.11975 9.81737 1.89918 9.35341 2.09219V2.09219C9.01343 2.23362 8.6217 2.1557 8.36172 1.89493V1.89493C8.00694 1.53906 7.43057 1.53906 7.07578 1.89493V1.89493C6.81581 2.1557 6.42407 2.23362 6.0841 2.09219Z"
      stroke="url(#paint0_linear_561_359)"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_561_359"
        x1="4.21226"
        y1="10.3928"
        x2="14.9684"
        y2="7.15346"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C49E19" />
        <stop offset="1" stopColor="#F5C518" />
      </linearGradient>
    </defs>
  </svg>
);
